/*
 * @Author: Teemo Ding
 * @Date: 2022-05-07 16:46:47
 * @LastEditTime: 2022-05-07 16:57:41
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/analytics/reportingDashboard.ts
 */
import { post } from 'src/tools/server';

export const reportDashboardInit = (data) => {
  return post<any>(`portal/report/dashboard`, data, {});
};
